export default class EmailRecovery {
    constructor(api) {
      this.api = api;
    }
  
    postEmail(email, onSuccess, onError) {
      return this.api.http_fibercloud
        .post("v1/password/email", {"email": email})
        .then(resp => {
          onSuccess(resp);
        })
        .catch(error => {
          onError(error);
        });
    }

    resetPassword(password, onSuccess, onError) {
        return this.api.http_fibercloud
          .post("v1/password/reset", password)
          .then(resp => {
            onSuccess(resp);
          })
          .catch(error => {
            onError(error);
          });
      }
  }


// WEBPACK FOOTER //
// ./src/api/emailRecovery.js